import {Component} from '@angular/core';
import {CloudinaryOptions, CloudinaryUploader} from 'ng2-cloudinary';
import {NgForm} from '@angular/forms';
import {Router, ActivatedRoute} from "@angular/router";
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import {ToastrService} from 'toastr-ng2';
@Component({
    selector: 'app-add-coupons',
    templateUrl: './add-coupons.component.html',
    styleUrls: ['./add-coupons.component.scss']
})
export class AddCouponsComponent {

    coupon: any = {
        name: '',
        value:'',
        date:''
    };
    couponData: FirebaseListObservable<any>;


    constructor(public af: AngularFireDatabase, public router: Router, public toastr: ToastrService) {
        this.couponData = af.list('/coupons');
    }

    onSubmitTag(form: NgForm) {
        this.coupon.date =  Date.now();
        this.couponData.push(this.coupon).then((res) => {
            this.router.navigate(['/coupons/all']);
            this.toastr.success('Coupon Added Successfully!', 'Success!');
        })
    }
     cancel(){
       this.router.navigate(['/coupons/all']);
    }
}




// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/routes/restaurant/coupons/add-coupons/add-coupons.component.ts